class RecentlyViewed {
  constructor(containerId, maxItems = 5) {
    this.container = document.getElementById(containerId);
    this.maxItems = maxItems;
    this.cookieName = 'shopify_recently_viewed';
    this.productHandles = this.getRecentlyViewedFromCookie();

    if (this.container) {
      this.init();
    }
  }

  init() {
    this.renderRecentlyViewedProducts();
  }

  // 从cookie获取最近浏览的商品handle
  getRecentlyViewedFromCookie() {
    const cookie = document.cookie.split('; ').find(row => row.startsWith(`${this.cookieName}=`));
    if (cookie) {
      try {
        return JSON.parse(decodeURIComponent(cookie.split('=')[1]));
      } catch (e) {
        console.error('Error parsing recently viewed cookie:', e);
        return [];
      }
    }
    return [];
  }

  // 将最近浏览的商品handle保存到cookie
  saveRecentlyViewedToCookie() {
    const d = new Date();
    d.setTime(d.getTime() + (30 * 24 * 60 * 60 * 1000)); // 30 days expiration
    const expires = 'expires=' + d.toUTCString();
    document.cookie = `${this.cookieName}=${encodeURIComponent(JSON.stringify(this.productHandles))}; ${expires}; path=/`;
  }

  // 添加商品到最近浏览列表
  addProduct(productHandle) {
    if (!productHandle) return;
    
    // 移除已存在的，确保最新浏览的在最前面
    this.productHandles = this.productHandles.filter(handle => handle !== productHandle);
    this.productHandles.unshift(productHandle);
    
    // 限制数量
    if (this.productHandles.length > this.maxItems) {
      this.productHandles = this.productHandles.slice(0, this.maxItems);
    }
    this.saveRecentlyViewedToCookie();
  }

  // 渲染最近浏览的商品
  async renderRecentlyViewedProducts() {
    if (!this.container) return;

    if (this.productHandles.length === 0) {
      this.container.innerHTML = '<p class="cart-drawer__recently-viewed-empty">暂无最近浏览的商品</p>';
      return;
    }

    this.container.innerHTML = '<div class="cart-drawer__recently-viewed-loading">加载中...</div>';

    try {
      const products = await this.fetchProducts(this.productHandles);
      if (products.length > 0) {
        this.container.innerHTML = this.generateProductHTML(products);
        this.bindAddToCartEvents();
      } else {
        this.container.innerHTML = '<p class="cart-drawer__recently-viewed-empty">暂无最近浏览的商品</p>';
      }
    } catch (error) {
      console.error('Error rendering recently viewed products:', error);
      this.container.innerHTML = '<p class="cart-drawer__recently-viewed-empty">加载最近浏览商品失败。</p>';
    }
  }

  // 批量获取商品数据
  async fetchProducts(handles) {
    const productData = [];
    for (const handle of handles) {
      try {
        const response = await fetch(`/products/${handle}.js`);
        if (response.ok) {
          const product = await response.json();
          productData.push(product);
        } else {
          console.warn(`Could not fetch product data for handle: ${handle}`);
        }
      } catch (error) {
        console.error(`Error fetching product ${handle}:`, error);
      }
    }
    return productData;
  }

  // 生成商品HTML
  generateProductHTML(products) {
    return products.map(product => {
      const firstVariant = product.variants[0];
      if (!firstVariant) return '';

      const compareAtPrice = firstVariant.compare_at_price ? `<span class="original-price">${this.formatMoney(firstVariant.compare_at_price)}</span>` : '';
      const currentPrice = this.formatMoney(firstVariant.price);

      return `
        <div class="cart-drawer__recently-viewed-item">
          <a href="${product.url}" class="cart-drawer__recently-viewed-image-link">
            <img src="${product.featured_image ? product.featured_image : ''}" alt="${product.title}" loading="lazy">
          </a>
          <div class="cart-drawer__recently-viewed-details">
            <h4 class="cart-drawer__recently-viewed-title"><a href="${product.url}">${product.title}</a></h4>
            <div class="cart-drawer__recently-viewed-price">
              <span class="current-price">${currentPrice}</span>
              ${compareAtPrice}
            </div>
          </div>
          <button type="button" class="cart-drawer__recently-viewed-add-btn" data-variant-id="${firstVariant.id}">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M8 4V12M4 8H12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Add
          </button>
        </div>
      `;
    }).join('');
  }

  formatMoney(cents) {
    if (typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, window.Shopify.money_format);
    }
    const amount = (cents / 100).toFixed(2);
    return `$${amount}`;
  }

  bindAddToCartEvents() {
    this.container.querySelectorAll('.cart-drawer__recently-viewed-add-btn').forEach(button => {
      button.addEventListener('click', async (e) => {
        const variantId = e.currentTarget.dataset.variantId;
        if (variantId && window.cartDrawer) {
          e.currentTarget.disabled = true;
          e.currentTarget.textContent = 'Adding...';
          await window.cartDrawer.addItem(variantId, 1);
          e.currentTarget.textContent = 'Added';
          setTimeout(() => {
            e.currentTarget.textContent = 'Add';
            e.currentTarget.disabled = false;
          }, 1500);
        }
      });
    });
  }
}

// 初始化RecentlyViewed
document.addEventListener('DOMContentLoaded', () => {
  console.log('DOM loaded, initializing RecentlyViewed...');
  window.recentlyViewed = new RecentlyViewed('recently-viewed-products-container');

  // 监听产品页面加载，将当前产品添加到最近浏览
  // 这需要一个机制来获取当前产品的handle，例如通过meta标签或全局JS变量
  if (Shopify && Shopify.routes && Shopify.routes.root) {
      const productHandleMeta = document.querySelector('meta[property="og:url"]');
      if (productHandleMeta) {
        const url = new URL(productHandleMeta.content);
        const pathParts = url.pathname.split('/');
        const productHandle = pathParts[pathParts.length - 1];
        if (productHandle && url.pathname.startsWith('/products/')) {
          window.recentlyViewed.addProduct(productHandle);
        }
      }
  }
});

// 暴露全局函数以便于集成
window.refreshRecentlyViewed = () => {
  if (window.recentlyViewed) {
    window.recentlyViewed.renderRecentlyViewedProducts();
  } else {
    console.error('RecentlyViewed not initialized');
  }
};
